export function createBlockheadClassName(block: string, element = 'Root') {
  return `Blockhead__${block}__${element}`;
}
